import Axios from "../Utils/sd-axios/Axios";

const ParokshaSevaService = {
  getAll: async () => {
    try {
      const resp = await Axios.get("/seva/all?sevaType=parokshaSeva");
      return resp.data;
    } catch (error) {
      console.log(error)
      if (error?.response?.status === 401) {
        throw new Error("Session Expired");
      } else if (
        error?.response?.status !== 500 &&
        error?.response?.data?.message
      ) {
        throw new Error(error?.response?.data?.message);
      } else {
        //console.error(error);
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : error?.response?.message ?error?.response?.message: "something is wrong");
      }
    }
  },
  bookings: async (bookingData, id) => {
    try {
      const resp = await Axios.post(`online-cart/new-cart`, bookingData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Code": id,
        },
      });
      return resp.data;
    } catch (error) {
      console.log({error: error?.response?.status , error2: error.data})
      if (error?.response?.status === 401) {
        throw new Error("Session Expired");
      } else if (
        error?.response?.status !== 500 &&
        error?.response?.data?.message
      ) {
        throw new Error(error?.response?.data?.message);
      } else {
        //console.error(error);
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : error?.response?.message ?error?.response?.message: "something is wrong");
      }
    }
  },
  getPratyakshaSlots: async (id, date) => {
    try {
      const resp = await Axios.get(
        `/seva/slots/available/${id}?bookingDate=${date}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "X-Temple-Id": process.env.REACT_APP_TEMPLE ? 2 : 10,
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        throw new Error("Session Expired");
      } else if (
        error?.response?.status !== 500 &&
        error?.response?.data?.message
      ) {
        throw new Error(error?.response?.data?.message);
      } else {
        // //console.error(error);
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : error?.response?.message ?error?.response?.message: "something is wrong");
      }
    }
  },
};

export default ParokshaSevaService;
